import { observer } from 'mobx-react';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import './msInputAC.css';

let watchScrollContainerId = null;
export function setACOptionsWatchScrollContainerId(containerId) {
  watchScrollContainerId = containerId;
}

let acOptionsEl = null;
export const ACOptions = observer(class ACOptions extends React.Component {
  static propTypes = {
    onContainerScroll: PropTypes.func,
  }

  constructor(props) {
    super(props);
    if (acOptionsEl == null) {
      acOptionsEl = document.createElement('div');
      acOptionsEl.style.zIndex = 9999;
      document.body.appendChild(acOptionsEl);
    }
  }

  componentDidMount() {
    document.body.appendChild(acOptionsEl);
    let cont = document.getElementById(watchScrollContainerId);
    if (cont) cont.addEventListener('scroll', this.handleContainerScroll);
  }

  componentWillUnmount() {
    if (document.body.contains(acOptionsEl)) document.body.removeChild(acOptionsEl);
    let cont = document.getElementById(watchScrollContainerId);
    if (cont) cont.removeEventListener('scroll', this.handleContainerScroll);
  }

  handleContainerScroll = () => {
    let { onContainerScroll } = this.props;
    if (onContainerScroll) {
      onContainerScroll(acOptionsEl.children[0]);
    }
  }

  render() {
    let { children } = this.props;
    return ReactDOM.createPortal(children, acOptionsEl);
  }
})
